import classNames         from 'classnames';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import LoupeIcon     from '../../../components/icons/LoupeIcon';
import ShowOnMapIcon from '../../../components/icons/ShowOnMapIcon';
import InternalVideo from '../../../components/internal-video';
import { useModal }  from '../../../providers/modal';

const TradeStoreItem = function(props) {
  const { t } = useTranslation();

  const {
          cities,
          currentCity,
          getFullAddress,
          highlight,
          isHighlighted,
          map,
          openGallery,
          setSearchQuery,
          tradeStore,
        } = props;

  const modal = useModal();

  const address     = React.useMemo(() => {
    if (currentCity) {
      return tradeStore.address;
    }

    const city   = cities.get(tradeStore.cityId);
    const prefix = t('field_cityLabel')
      .charAt(0)
      .toLowerCase();

    return `${prefix}. ${city.label}, ${tradeStore.address}`;
  }, [currentCity, tradeStore.address, tradeStore.cityId]);
  const contacts    = React.useMemo(() => {
    return (
      <>
        {tradeStore.contacts.map((contact, index) => {
          switch (contact.type) {
            case 'email':
              return (
                <div
                  className={'site'}
                  key={index}
                >
                  <a href={`mailto:${contact.label}`}>{contact.label}</a>
                </div>
              );

            case 'phone':
              return (
                <div
                  className={'phone'}
                  key={index}
                >
                  <a href={`tel:${contact.label}`}>{contact.label}</a>
                </div>
              );

            case 'site':
              return (
                <div
                  className={'site'}
                  key={index}
                >
                  <a
                    href={contact.label}
                    rel={classNames('noopener', {
                      nofollow:   contact.nofollow,
                      noindex:    contact.noindex,
                      noreferrer: contact.noreferrer,
                    })}
                    target={'_blank'}
                  >{contact.label
                    .replace(/^https?:\/\//, '')
                    .replace(/\/$/, '')
                  }</a>
                </div>
              );

            default:
              return null;
          }
        })}
      </>
    );
  }, [tradeStore.contacts]);
  const formatDoors = React.useMemo(() => {
    if (!DV.isNotEmptyArray(tradeStore.productTypes)) {
      return;
    }

    const [first, second] = tradeStore.productTypes;

    if (!second) {
      return first.label;
    }

    return `${first.label.replace(' двери', '')} ${t('and')} ${second.label.toLowerCase()}`;
  }, [tradeStore.productTypes]);
  const payments    = React.useMemo(() => {
    if (tradeStore.payments.length === 1) {
      const [{ label }] = tradeStore.payments;

      return <div className={'calculation'}>{label}</div>;
    }

    return (
      <div className={'calculation'}>
        {tradeStore.payments.map((payment, index) => {
          if (index === 0) {
            const searchValue = t('client_calculation')
              .toLowerCase();

            return payment.label.replace(` ${searchValue}`, '');
          }

          return payment.label.toLowerCase();
        })
          .join(` ${t('and')} `)}
      </div>
    );
  }, [tradeStore.payments]);

  const handleImageClick = React.useCallback((tradeStore) => {
    if (DV.isArray(tradeStore.slider) && tradeStore.slider.length > 0 || tradeStore.image) {
      openGallery([tradeStore.image, ...tradeStore.slider]);
    }
  }, [openGallery]);
  const handleOpenVideo  = React.useCallback((src) => {
    modal.showModal(
      '',
      {
        component: InternalVideo,
        props:     {
          controls: true,
          src,
        },
      },
      true,
      'trade-store-video',
    );
  }, []);

  return (
    <div
      className={classNames('trade_store_item', { highlight: isHighlighted })}
      onClick={() => {
        setSearchQuery(getFullAddress(tradeStore));
        highlight(tradeStore);
      }}
    >
      <div className={'trade_store_item_description'}>
        {DV.isNotEmptyString(tradeStore.typeTradeStore) && (
          <div className={'type_trade_store'}>{tradeStore.typeTradeStore}</div>
        )}
        <div className={'address'}>{address}</div>
        <div>{contacts}</div>
        {DV.isString(tradeStore.workTime) && (
          <div
            className={'working_time'}
            dangerouslySetInnerHTML={{ __html: tradeStore.workTime }}
          />
        )}
        {!DV.isUndefined(formatDoors) && (
          <div className={'door_types'}>
            <p>{formatDoors}</p>
          </div>
        )}
        <div>{payments}</div>
        {!DV.isUndefined(tradeStore.video) && !DV.isNull(tradeStore.video) && (
          <div
            className={'btn fill'}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();

              handleOpenVideo(tradeStore.video);
            }}
          >Смотреть видеообзор</div>
        )}
      </div>
      {DV.isString(tradeStore.image) && (
        <div
          className={'picture_container'}
          onClick={() => handleImageClick(tradeStore)}
        >
          <picture>
            <source
              src={`${tradeStore.image}.webp?w=300&default=horizontal&t=${BUILD_TIME}`}
              type={'image/png'}
            />
            <source
              src={`${tradeStore.image}.webp?w=300&default=horizontal&t=${BUILD_TIME}`}
              type={'image/webp'}
            />
            <img
              alt={`${tradeStore.label} = ${tradeStore.address}`}
              src={`${tradeStore.image}.png?default=horizontal&t=${BUILD_TIME}`}
            />
          </picture>
          <div className={'loupe_container'}>
            <LoupeIcon />
          </div>
        </div>
      )}
      <div
        className={'show_on_map_container'}
        onClick={() => {
          map.current?.scrollIntoView({
            behavior: 'smooth',
            block:    'start',
          });
        }}
      >
        <ShowOnMapIcon />
      </div>
    </div>
  );
};

export default TradeStoreItem;